<template>
  <div class="error-content">
    <div class="error-content__title">
      {{ $t('Errors.ServerError') }}
    </div>
    <div
      class="ml-4 pt-4 pb-4 text-left h4-headline opacity-7">
      <div>{{ $t('Errors.ServerErrorText.0') }}</div>
      <div>{{ $t('Errors.ServerErrorText.1') }}</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'error500',
}
</script>
<style lang="scss" scoped>
.error-content {
  &__title {
    text-align: left;
    margin-left: 16px;
    font-weight: 600;
    font-size: 24px;
    letter-spacing: 0.01em;
    @media (max-width:935px) {
      margin-left: 0;
      text-align: center;
    }
  }
}
</style>
